import React, {Component} from 'react';
class Footer extends Component {
  render(){
    return(
      <footer class="bg-dark text-center navbar-dark text-lg-start">
  <div class="text-center text-white p-3">
    © 2022 Copyright:
    <a class="text-white p-3" href="https://mdbootstrap.com/">Ananya Gupta</a>
  </div>
</footer>
);
  }
}
export default Footer;
